<template>
    <div class="linked-record-cell" @mouseenter="showMenu = true" @mouseleave="hideMenu">
        <!-- Eğer alanın değeri varsa göster, yoksa ekle butonu göster -->
        <div v-if="linkedRecord" class="linked-record-info" @click="viewLinkedRecord(linkedRecord)">
            <i class="material-icons">switch_access_shortcut</i>
            <span class="linked-record-label">{{ getLabel(linkedRecord) }}</span>
        </div>
        <PermissionController :permissions="['table.update']" v-else>
            <a @click="showRecordPicker">+ Kayıt Ekle</a>
        </PermissionController>

        <!-- Hover menüsü -->
        <div class="linked-record-menu" @mouseenter="cancelHide" @mouseleave="hideMenu" v-if="showMenu && linkedRecord">
            <PermissionController :permissions="['table.update']">
                <SupsisButton icon="edit" @click="editLinkedRecord" xxsmall />
            </PermissionController>
            <PermissionController :permissions="['table.update']">
                <SupsisButton icon="delete" @click="removeLinkedRecord" xxsmall />
            </PermissionController>
        </div>

        <!-- Record seçme Modal'ı -->
        <Modal2
            v-if="showModal"
            @cancel="closeModal"
            :title="'Kayıt Seç'"
            :okText="'Kaydet'"
            xlarge
            className="record-picker-modal keydown-prevent-modal"
        >
            <RecordPicker
                :table-id="field.options.linkedRecord.table"
                :pickerMode="true"
                @record-selected="onRecordSelected"
                :labelFieldId="field.options.linkedRecord.labelField"
            />
        </Modal2>
    </div>
</template>

<script>
import Vue from "vue";
import Modal2 from "../../../../../components/common/Modal2.vue";
// RecordPicker bileşeni, TableDetail veya başka bir bileşen olabilir.
// Projede mevcut bileşeni kullanarak içeri aktardığınızı varsayıyoruz.
import RecordPicker from "../pickers/RecordPicker.vue";
import { mapActions, mapState } from "vuex";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "LinkedRecordCell",
    components: {
        Modal2,
        RecordPicker,
        SupsisButton,
    },
    props: {
        record: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showMenu: false,
            showModal: false,
            hideTimeout: null,
        };
    },
    computed: {
        linkedRecord() {
            const table = this.tables.find((t) => t._id === this.field.options.linkedRecord.table);

            // Hücredeki linked-record tipi alanın verisini okuyacağız
            return this.record.data && this.record.data[this.field._id];
        },
        ...mapState({
            tables: (state) => state.table.tables,
        }),
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
        }),
        showRecordPicker() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        cancelHide() {
            if (this.hideTimeout) {
                clearTimeout(this.hideTimeout);
            }
        },
        hideMenu() {
            this.hideTimeout = setTimeout(() => {
                this.showMenu = false;
            }, 200);
        },
        getLabel(recordData) {
            // Linked kaydın label'ı ne olacaksa burada dönüyoruz.
            // Örneğin recordData.label gibi bir yapı olabilir.
            // Projede, listRecords ile dönen kayıtta label alanını nasıl saklıyorsanız ona göre uyarlayınız.
            const remoteTable = this.tables.find((t) => t._id === this.field.options.linkedRecord.table);
            const labelField = this.field.options.linkedRecord.labelField;
            const remoteField = remoteTable.fields.find((f) => f._id === labelField);
            const isContactField = remoteField.fieldType === "contact";
            if (isContactField) {
                const contact = _.get(recordData, `data.${labelField}`, undefined);
                return contact ? contact.fullname : "İsimsiz Kişi";
            } else if (remoteField.fieldType === "user") {
                const user = _.get(recordData, `data.${labelField}`, undefined);
                return user ? user.name : "İsimsiz Kullanıcı";
            } else if (remoteField.fieldType === "conversation") {
                return "Chat";
            } else {
                return _.get(recordData, `data.${labelField}`, "Bağlı Kayıt");
            }
        },
        onRecordSelected(selectedRecord) {
            // Seçilen kaydı alanın verisi olarak güncelle
            console.log("selectedRecord", selectedRecord);
            this.updateLinkedRecord(selectedRecord);
            this.closeModal();
        },
        removeLinkedRecord() {
            // Alanı boşalt
            this.$emit("update-record", {
                recordId: this.record._id,
                fieldId: this.field._id,
                value: null,
            });
        },
        editLinkedRecord() {
            this.viewLinkedRecord(this.linkedRecord);
        },
        viewLinkedRecord(linkedRecordData) {
            // Kayıt görüntüleme akışı
            // Burada sadece tıklama ile kaydı yeni sayfada açmayı örnekledik.
            const table = this.tables.find((t) => t._id === this.field.options.linkedRecord.table);
            const title = `${table.name} - ${this.$t("modules.recordViewer")} (${this.getLabel(linkedRecordData)})`;

            this.addNewWindow({
                id: linkedRecordData._id,
                type: "table-record-viewer",
                title: `${table.name} - ${this.getLabel(linkedRecordData)}`,
                payload: {
                    tableId: table._id,
                    recordId: linkedRecordData._id,
                },
                multiple: true,
                autoClose: false,
            });
        },
        async updateLinkedRecord(newRecord) {
            console.log("newRecord", newRecord);

            await this.$emit("update-record", {
                recordId: this.record._id,
                fieldId: this.field._id,
                value: newRecord._id,
            });
        },
    },
});
</script>

<style scoped lang="scss">
.linked-record-cell {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .linked-record-info {
        display: flex;
        align-items: center;
        padding: 4px;
        border-radius: 4px;
        cursor: pointer;
        gap: 8px;
        transition: background-color 0.2s ease;

        &:hover {
            background-color: #c0e0f5;

            span {
                text-decoration: underline;
            }
        }
    }

    .linked-record-label {
        font-weight: 500;
    }

    .linked-record-menu {
        position: absolute;
        right: -14px;
        top: 50%;
        transform: translateY(-50%);
        transition: transform 0.3s ease;
        z-index: 10;
        height: 100%;
        width: max-content;
        background: #0000002b;
        display: flex;
        justify-content: flex-end;
        gap: 5px;
        align-items: center;
        padding: 0 10px;
    }
}
</style>
